import request from '@/utils/ajax';

export function addProduct(data) {
  return request({
    url: '/wx/manage/authorizedProduct/save',
    method: 'post',
    data: data
  });
}

export function editProduct(data) {
  return request({
    url: '/wx/manage/authorizedProduct/update',
    method: 'put',
    data: data
  });
}

export function deleteProduct(data) {
  return request({
    url: '/wx/manage/authorizedProduct/delete',
    method: 'post',
    data: data
  });
}
